angular.module('hcap-analytics')
.controller('PremiumLandingCtrl', [
  '$scope',
  function(
    $scope,
  ) {
    sessionStorage.setItem('premiumPortal', 'true');

    $scope.landingPageClass = 'premium-landing-page';
    $scope.landingTitle = 'HCAP Analytics Premium';
    $scope.landingSubtitle = 'Unlock your potential at work';

    $scope.data = {
      mode: 'SIGN_IN',
    };

    $scope.navTab = mode => {
      $scope.data.mode = mode;
    };
  },
]);
